import React from 'react';
import styles from '@/components/staffer/Grading/QuestionCards/questionCard.module.scss';
import { StudentAnswerProps } from '@/components/staffer/Grading/types';
import GradingView from '@/components/common/Forms/Questions/DragAndDrop/Answer/GradingView';
import { noAnswerProvided } from '@/components/staffer/Grading/utils';

const DragAndDropQuestionStudentAnswer = ({ question, questionAnswer }: StudentAnswerProps) => {
  if (!questionAnswer?.answer_data?.attempts_made?.length) return noAnswerProvided();

  return (
    <div className={`${styles.dndAnswerContainer} drag-and-drop-${question.id}`}>
      <GradingView
        locale="en"
        parentContainerId={`drag-and-drop-${question.id}`}
        question={question}
        studentId={questionAnswer.student_id.toString()}
      />
    </div>
  );
};

export default DragAndDropQuestionStudentAnswer;
